import { Tab, TabsGroup } from '@billy/design-system'
import React, { ReactElement, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useLocalStorageUncontrolled } from '../../../../hooks/useLocalStorageUncontrolled'
import { REPORTS_IDS, REPORTS_ROUTE_LABEL_KEYS } from '../../constants/reportsRouteConfig'
import { REPORTS_ROUTE_STORAGE_KEY } from '../../constants/reportsRouteStorageKey'
import { getReportsRouteUrl } from '../../utils/getReportsToRouteUrl'
import { isRouteValid } from '../../utils/isRouteValid'
import * as Styled from './styles'

export const ReportsNavigationTabs = (): ReactElement => {
  const { t } = useTranslation()
  const location = useLocation()
  const { organization } = useUserOrganization()
  const { setItem } = useLocalStorageUncontrolled(REPORTS_ROUTE_STORAGE_KEY)

  const currentRoute = REPORTS_IDS.find((id) => getReportsRouteUrl(organization?.url, id) === location.pathname)

  useEffect(() => {
    if (isRouteValid(location.pathname, organization?.url)) {
      setItem(location.pathname)
    }
  }, [location.pathname, organization?.url, setItem])

  const navigationTabs = useMemo(
    () =>
      REPORTS_IDS.map((route) => ({
        name: t(REPORTS_ROUTE_LABEL_KEYS[route]),
        route,
        url: getReportsRouteUrl(organization?.url, route),
      })),
    [t, organization?.url],
  )

  return (
    <Styled.ReportsNavigationTabsWrapper>
      <TabsGroup>
        {navigationTabs.map(({ name, route, url }) => (
          <Tab key={route} active={currentRoute === route} to={url}>
            {name}
          </Tab>
        ))}
      </TabsGroup>
    </Styled.ReportsNavigationTabsWrapper>
  )
}
